var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 0C19.2907 0 0 19.2907 0 43C0 66.7093 19.2907 86 43 86C66.7093 86 86 66.7093 86 43C86 19.2907 66.7093 0 43 0ZM67.0326 31.6842L39.5514 58.9499C37.9348 60.5664 35.3484 60.6742 33.6241 59.0576L19.0752 45.802C17.3509 44.1855 17.2431 41.4912 18.7519 39.7669C20.3684 38.0426 23.0627 37.9348 24.787 39.5514L36.3183 50.1128L60.8897 25.5414C62.614 23.817 65.3083 23.817 67.0326 25.5414C68.7569 27.2657 68.7569 29.9599 67.0326 31.6842Z",
    fill: "#23A085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkRounded);
export default __webpack_public_path__ + "static/media/checkmark-rounded.78fb6c8ca3654bd1377d8897f24c590b.svg";
export { ForwardRef as ReactComponent };